import React, { useState } from "react";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
  Box,
  Button,
  CardContent,
  Card,
} from "@mui/material";
import AddressModule from "./AddressModule";
import { placeOrder } from "services/apiService";
import toast from "react-hot-toast";
import DatePickerModal from "common/DatePicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

const Cart = ({
  cartItems,
  cartTotalAmount,
  handleDelete,
  handleUpdate,
  user,
}) => {
  const [quantities, setQuantities] = useState(() =>
    cartItems.reduce((acc, item) => {
      acc[item.product_id] = 1;
    }, {})
  );
  const [orderDate, setOrderDate] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);

  const AppUrl = process.env.REACT_APP_IMAGE_URL;

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleIncrease = (productId) => {
    const updatedQuantity = (quantities[productId] || 1) + 1;
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [productId]: updatedQuantity,
    }));
    handleUpdate(productId, updatedQuantity);
  };

  const handleDecrease = (productId) => {
    const updatedQuantity = Math.max(1, (quantities[productId] || 1) - 1);
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [productId]: updatedQuantity,
    }));

    handleUpdate(productId, updatedQuantity);
  };

  const handleBillingCardSelect = (card: any) => {
    setSelectedBillingAddress(card);
  };

  const handleShippingCardSelect = (card: any) => {
    setSelectedShippingAddress(card);
  };

  const isDisabled =
    selectedBillingAddress === null || selectedShippingAddress === null;

  const handlePlaceOrder = async () => {
    try {
      const payload = {
        billing_address_id: Number(selectedBillingAddress.billing_address_id),
        shipping_address_id: Number(
          selectedShippingAddress.shipping_address_id
        ),
        order_date: orderDate ? orderDate : null,
        user_id: Number(user),
      };
      const response = await placeOrder(payload);
      if (response.status_code === 200) {
        toast.success("order Place succefully");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      toast.error("error while placing the order");
    }
  };

  return (
    <>
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom>
          Cart
        </Typography>
        <hr />
        <TableContainer
          component={Paper}
          elevation={3}
          sx={{ borderRadius: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.NO</TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Original Price</TableCell>

                <TableCell>Sales Price</TableCell>
                <TableCell>Tax Amount</TableCell>
                <TableCell>Sub Total</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cartItems.map((item, index) => (
                <TableRow key={item.product_id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.product_name}</TableCell>
                  <TableCell>
                    <Avatar
                      src={`${
                        item.thumnail_image
                          ? AppUrl + item.thumnail_image
                          : "/placeholder.png"
                      }`}
                      alt={item.product_name}
                      variant="square"
                      sx={{ width: 50, height: 50 }}
                    />
                  </TableCell>
                  <TableCell>₹ {Math.round(item.original_price)}</TableCell>
                  <TableCell>₹ {Math.round(item.sales_price)}</TableCell>
                  <TableCell>₹ {Math.round(item.tax_amount)}</TableCell>
                  <TableCell>₹ {Math.round(item.sub_total)}</TableCell>

                  <TableCell>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        color="primary"
                        onClick={() => handleDecrease(item.product_id)}
                        disabled={quantities[item.product_id] <= 1}
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </IconButton>
                      <Typography
                        sx={{
                          width: 30,
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        {quantities[item.product_id] || 1}
                      </Typography>
                      <IconButton
                        color="primary"
                        onClick={() => handleIncrease(item.product_id)}
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </IconButton>
                    </div>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(item.product_id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              borderRadius: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
                p: 3,
                margin: "0 auto",
                bgcolor: "background.paper",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Card
                  sx={{
                    flex: 1,
                    borderRadius: "1px",
                    minWidth: "500px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #ddd",
                    p: 3,
                    bgcolor: selectedBillingAddress ? "#e3f2fd" : "#ffffff",
                    transition: "background-color 0.3s ease",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        mb: 2,
                        textAlign: "strat",
                        color: "grey",
                        textTransform: "uppercase",
                      }}
                    >
                      Billing Address
                    </Typography>
                    <hr />
                    {selectedBillingAddress ? (
                      <>
                        <Grid container spacing={2}>
                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Name:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedBillingAddress.billing_name}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Email:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedBillingAddress.billing_email}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Phone:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedBillingAddress.billing_phone_no}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Address:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedBillingAddress.billing_address_line_one},{" "}
                              {selectedBillingAddress.billing_address_line_two}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              City:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedBillingAddress.billing_city},{" "}
                              {selectedBillingAddress.billing_state},{" "}
                              {selectedBillingAddress.billing_country}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Pincode:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedBillingAddress.billing_pincode}
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                    ) : (
                      <Typography sx={{ color: "#999", fontStyle: "italic" }}>
                        No billing address selected.
                      </Typography>
                    )}
                  </CardContent>
                </Card>

                <Card
                  sx={{
                    flex: 1,
                    borderRadius: "1px",
                    minWidth: "500px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #ddd",
                    p: 3,
                    bgcolor: selectedShippingAddress ? "#e8f5e9" : "#ffffff",
                    transition: "background-color 0.3s ease",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        mb: 2,
                        textTransform: "uppercase",
                        textAlign: "start",
                        color: "grey",
                      }}
                    >
                      Shipping Address
                    </Typography>
                    <hr />
                    {selectedShippingAddress ? (
                      <>
                        <Grid container spacing={2}>
                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Name:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedShippingAddress.shipping_name}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Email:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedShippingAddress.shipping_email}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Phone:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedShippingAddress.shipping_phone_no}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Address:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {
                                selectedShippingAddress.shipping_address_line_one
                              }
                              ,{" "}
                              {
                                selectedShippingAddress.shipping_address_line_two
                              }
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              City:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedShippingAddress.shipping_city},{" "}
                              {selectedShippingAddress.shipping_state},{" "}
                              {selectedShippingAddress.shipping_country}
                            </Typography>
                          </Grid>

                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "600", height: "36px" }}
                            >
                              Pincode:
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography variant="body2">
                              {selectedShippingAddress.shipping_pincode}
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                    ) : (
                      <Typography sx={{ color: "#999", fontStyle: "italic" }}>
                        No shipping address selected.
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Box>

              <Button
                variant="outlined"
                color="secondary"
                onClick={handleOpenModal}
              >
                Select Address
              </Button>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                mt: 2,
                backgroundColor: "#f5f5f5",
                padding: 3,
                width: "100%",
                maxWidth: "500px",
                maxHeight: "500px",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  borderBottom: "2px solid #1976d2",
                  paddingBottom: 1,
                  color: "#333",
                  textAlign: "left",
                  width: "100%",
                  mb: 2,
                }}
              >
                Invoice Summary
              </Typography>

              <Box sx={{ width: "100%" }}>
                {[
                  {
                    label: "Total Products",
                    value: cartTotalAmount?.total_products,
                  },
                  { label: "Total Count", value: cartTotalAmount?.total_count },
                  {
                    label: "Total Original Amount",
                    value: `₹${cartTotalAmount?.total_original_amount || "-"}`,
                  },
                  {
                    label: "Total Discount Amount",
                    value: `₹${cartTotalAmount?.total_discount_amount || "-"}`,
                  },
                  {
                    label: "Total Tax Amount",
                    value: `₹${cartTotalAmount?.total_tax_amount || "-"}`,
                  },
                  {
                    label: "Total Sales Amount",
                    value: `₹${
                      cartTotalAmount?.total_sales_amount
                        ? Math.round(cartTotalAmount.total_sales_amount)
                        : "-"
                    }`,
                  },
                  {
                    label: "Coupon Discount Price",
                    value: `₹${cartTotalAmount?.coupen_discount_price || "-"}`,
                  },

                  {
                    label: "Total Price",
                    value: `₹${
                      cartTotalAmount?.total_price
                        ? Math.round(cartTotalAmount.total_price)
                        : "-"
                    }`,
                    isHighlight: true,
                  },
                ].map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1.5,
                      color: item.isHighlight ? "#1976d2" : "#555",
                      fontWeight: item.isHighlight ? "bold" : "normal",
                    }}
                  >
                    <Typography variant="subtitle2">{item.label}</Typography>
                    <Typography variant="subtitle2">
                      {item.value === null ||
                      item.value === undefined ||
                      item.value === ""
                        ? "-"
                        : item.value}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Button
                sx={{
                  width: "100%",
                  marginTop: "40px",
                }}
                variant="outlined"
                color="success"
                onClick={() => setOpen(true)}
                disabled={isDisabled}
              >
                {orderDate ? (
                  <p>Selected Date: {orderDate}</p>
                ) : (
                  <p>add order date (optional)</p>
                )}
              </Button>
              <DatePickerModal
                open={open}
                onClose={() => setOpen(false)}
                onDateSelect={(date) => {
                  setOrderDate(date);
                }}
              />
              <Button
                sx={{
                  width: "100%",
                  marginTop: "10px",
                }}
                variant="contained"
                disabled={isDisabled}
                onClick={() => handlePlaceOrder()}
              >
                PLACE ORDER
              </Button>
            </Box>
          </div>
        </TableContainer>
      </Grid>
      <AddressModule
        userId={user}
        open={isModalOpen}
        onClose={handleCloseModal}
        onBillingCardSelect={handleBillingCardSelect}
        onShippingCardSelect={handleShippingCardSelect}
      />
    </>
  );
};

export default Cart;
